<template>
  <div id="hot-deals-section">
    <div
      class="deals-container relative container container-m z-level-3 padding-max-bottom">
      <h2 class="title text-center padding-l-top">Hot Deals</h2>
      <div class="relative">
        <slider
          v-if="deals.length != 0"
          class="m-bg-bg"
          navigation-bg-theme="gray-4"
          navigation-theme="bg"
          :config="{
            parallax: false,
            spaceBetween: 20,
            breakpoints: {
              1024: {
                slidesPerView: 4,
              },
              350: {
                slidesPerView: 1.7,
                spaceBetween: 140,
              },
            },
          }">
          <slide v-for="deal in deals" :key="deal.id" class="bg-bg">
            <deal-intro :hoverable="false" :product="deal"></deal-intro>
          </slide>
        </slider>
      </div>
    </div>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";

export default {
  name: "HotDeals",
  setup(props) {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);

    return {
      asyncOps,
      asyncOpsReady,
      asyncStatus,
    };
  },
  data() {
    return {
      deals: [],
      asyncData: {
        deals: {
          target: "justopp/deals",
          data: {
            filters: { featured: true },
            ordering: { key: "id", direction: "desc" },
          },
          options: {
            dataMutator: (data) => {
              return data.items ? data.items : [];
            },
          },
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.deals-container {
  @media (max-width: 1024px) {
    max-width: 310px !important;
    padding-inline: 0 !important;
    margin-inline: auto;
  }

  --swiper-navigation-sides-offset: calc(var(--margin-l) * -4);
}

:deep(.swiper) {
  @media (min-width: 1024px) {
    position: static !important;
  }
}

#hot-deals-section {
  background-color: var(--c-light-gray);
}

.title {
  @media (min-width: 1024px) {
    padding-top: var(--margin-2xl) !important;
  }
}

.m-bg-bg {
  @media (max-width: 1024px) {
    background-color: var(--c-bg);
  }
}
</style>
